import React, { FC } from 'react';
import { ProductCategorySection } from './ProductCategorySection';
import { LoadingAnimation } from '../LoadingAnimation';
import { Colors } from '../../../styles/colors';
import { Product, ProductCategory } from '../../../interfaces/Product';
import styled from 'styled-components';
import { FlexboxVertical } from '../Layout';

const Content = styled(FlexboxVertical)`
	color: ${Colors.grayDark};
	margin-bottom: 1.5rem;
`;

interface Props {
  filteredList?: ProductCategory[];
  productsList: ProductCategory[];
  onProductItemClick?: (productItem: Product) => void;
  activeSections?: string[];
  setActiveSections?: (sections: string[]) => void;
  additionalList?: boolean;
  showTechnicalName?: boolean;
}
export const ProductCategoryList: FC<Props> = ({ filteredList, productsList, onProductItemClick, ...props }) => {
  return (
    <Content>
      {
        (filteredList || productsList) && (filteredList || productsList).filter(({ products }) => products?.length > 0)
          .sort((a, b) => a.name?.localeCompare(b.name))
          .map((item, index) => (
            <ProductCategorySection
              additionalList={props?.additionalList || false}
              key={index}
              item={item}
              unfilteredItem={productsList.find(({ id }) => id === item.id)}
              index={index}
              active={props.activeSections ? props.activeSections.includes(`${index}`) : true}
              setActive={props.setActiveSections && ((active) => {
                if (props.setActiveSections) {
                  const nextSections = (props.activeSections || []).filter((value) => value !== `${index}`);
                  if (active) {
                    nextSections.push(`${index}`);
                  }
                  props.setActiveSections(nextSections);
                }
              })}
              showTechnicalName={props.showTechnicalName}
              onProductItemClick={onProductItemClick}
            />
          )) || <LoadingAnimation transparent />
      }
    </Content>
  )
}
